export default __webpack_public_path__ + "static/james-c459680f1da1e8218f3f29b8f802fd93.png";